// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lHwy","rootNoMargin":"styles_rootNoMargin__7Jchr"};